import { StringColumn, NumericalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	name: 'name',
	description: 'description',
	share: 'share'
};

export const bucketsConfig = [
	StringColumn({
		title: 'Name',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.name]
	}),
	StringColumn({
		title: 'Description',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.description] || ''
	}),
	NumericalColumn({
		title: 'Share (Sum will be 100)',
		mapDataToValue: (data: any) => data[COL_NAMES.share],
		maxWidth: 200
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 0,
		pageSize: 100
	},
	sortDetails: {
		sortField: 'code',
		sortOrder: 'ASC'
	}
};
